module.exports = {
  AtomicBoxPlugin: {
    PluginName: "Elemento de Contenido IA",
    accordion_element: "Elemento",
    accordion_style: "Estilo",
    element_type: "Tipo",
    theme_id: "Tema",
    padding: "Relleno",
    background_color: "Fondo",
    border_width: "Grosor del borde",
    border_style: "Estilo del borde",
    border_color: "Color del borde",
    border_radius: "Radio",
    opacity: "Opacidad",
    loading: "Cargando…",
    error: "Renderización no disponible",
    element_types: {
      heading: "Encabezado",
      eyebrow: "Antetítulo",
      footer: "Pie",
      quote: "Cita",
      "bullet-list": "Lista con viñetas",
      "card-grid": "Cuadrícula de tarjetas",
      timeline: "Línea de tiempo",
      "stat-group": "Estadísticas",
      hero: "Hero",
      section: "Sección",
      "two-column": "Dos Columnas",
      comparison: "Comparación",
      divider: "Divisor",
      badge: "Insignia",
      "cta-button": "Botón de Acción",
      "icon-block": "Bloque de Icono",
    },
  },
};
